export const ANALYTICS_EVENTS = {
  PUBLIC_LIST_VIEWED: "public_list_viewed",
  PUBLIC_LIST_CTA_CLICKED: "public_list_cta_clicked",
  INSTALL_ATTRIBUTED: "install_attributed",

  DEEP_LINK_RECEIVED: "deep_link_received",
  DEEP_LINK_FAILED: "deep_link_failed",
  REFERRAL_FOLLOW_PROCESSED: "referral_follow_processed",

  CAPTURE_STARTED: "capture_started",
  CAPTURE_COMPLETED: "capture_completed",
  CAPTURE_FAILED: "capture_failed",
  PAYWALL_VIEWED: "paywall_viewed",
  TRIAL_STARTED: "trial_started",
  SUBSCRIPTION_CONVERTED: "subscription_converted",
  PAYWALL_DISMISSED: "paywall_dismissed",
  PAYWALL_SKIPPED: "paywall_skipped",
  SUBSCRIPTION_PURCHASE_UNCLASSIFIED: "subscription_purchase_unclassified",
  SUBSCRIPTION_LIFECYCLE_CHANGED: "subscription_lifecycle_changed",
  SUBSCRIPTION_MANAGE_OPENED: "subscription_manage_opened",

  SIGN_IN_METHOD_SELECTED: "sign_in_method_selected",
  SIGN_IN_COMPLETED: "sign_in_completed",
  SIGN_IN_FAILED: "sign_in_failed",
  SIGN_IN_CANCELLED: "sign_in_cancelled",
  SIGN_UP_STARTED: "sign_up_started",
  SIGN_UP_COMPLETED: "sign_up_completed",
  SIGN_UP_FAILED: "sign_up_failed",
  GUEST_DATA_TRANSFER_COMPLETED: "guest_data_transfer_completed",
  ACCOUNT_DELETED: "account_deleted",

  ONBOARDING_SCREEN_VIEWED: "onboarding_screen_viewed",

  WELCOME_CTA_TAPPED: "welcome_cta_tapped",
  FOLLOW_CONTEXT_BANNER_SHOWN: "follow_context_banner_shown",
  ONBOARDING_DEMO_CAPTURE_TAPPED: "onboarding_demo_capture_tapped",
  ONBOARDING_REFERRAL_NOTE_SHOWN: "onboarding_referral_note_shown",

  NOTIFICATION_PERMISSION_REQUESTED: "notification_permission_requested",
  NOTIFICATION_PERMISSION_RESOLVED: "notification_permission_resolved",
  NOTIFICATION_PERMISSION_ERROR: "notification_permission_error",

  CAPTURE_CANCELLED: "capture_cancelled",
  CAPTURE_PERMISSION_DENIED: "capture_permission_denied",

  CAPTURE_COMPLETION_BANNER_SHOWN: "capture_completion_banner_shown",
  CAPTURE_COMPLETION_BANNER_TAPPED: "capture_completion_banner_tapped",

  EVENT_VIEWED: "event_viewed",
  PROFILE_VIEWED: "profile_viewed",

  EVENT_ADD_TO_CALENDAR_CANCELLED: "event_add_to_calendar_cancelled",
  EVENT_ADD_TO_CALENDAR_PERMISSION_DENIED:
    "event_add_to_calendar_permission_denied",
  EVENT_EDITED: "event_edited",
  EVENT_DELETED: "event_deleted",
  EVENT_ARCHIVED: "event_archived",
  EVENT_UNARCHIVED: "event_unarchived",
  EVENT_VISIBILITY_TOGGLED: "event_visibility_toggled",
  EVENT_ADDED_TO_LIST: "event_added_to_list",
  EVENT_DIRECTIONS_OPENED: "event_directions_opened",
  EVENT_UNSAVE_FAILED: "event_unsave_failed",

  LIST_SUBSCRIBED: "list_subscribed",
  LIST_SUBSCRIBE_FAILED: "list_subscribe_failed",
  LIST_SHARING_MODE_UPDATED: "list_sharing_mode_updated",
  LIST_SHARE_DESCRIPTION_UPDATED: "list_share_description_updated",
  LIST_SEARCH_PERFORMED: "list_search_performed",
  SHARE_LIST_INITIATED: "share_list_initiated",
  SHARE_LIST_COMPLETED: "share_list_completed",
  SHARE_LIST_DISMISSED: "share_list_dismissed",

  CALENDAR_FEED_SUBSCRIBED: "calendar_feed_subscribed",
  CALENDAR_FEED_UPSELL_OPENED: "calendar_feed_upsell_opened",

  NOTIFICATION_DEEP_LINK_FAILED: "notification_deep_link_failed",
  FEED_SEGMENT_TOGGLED: "feed_segment_toggled",

  SHARE_SETUP_VIEWED: "share_setup_viewed",
  SHARE_SETUP_COMPLETED: "share_setup_completed",
  SHARE_SETUP_DISMISSED: "share_setup_dismissed",

  RATING_PROMPT_SHOWN: "rating_prompt_shown",

  EVENT_REPORT_SUBMITTED: "event_report_submitted",

  ENRICHMENT_REPORT_SUBMITTED: "enrichment_report_submitted",

  ENRICHMENT_REQUESTED: "enrichment_requested",
  AUTO_ENRICH_PRIVATE_EVENTS_TOGGLED: "auto_enrich_private_events_toggled",

  WHATS_NEW_CHIP_TAPPED: "whats_new_chip_tapped",
  WHATS_NEW_CHIP_DISMISSED: "whats_new_chip_dismissed",
  WHATS_NEW_SLIDE_VIEWED: "whats_new_slide_viewed",
  WHATS_NEW_TOUR_COMPLETED: "whats_new_tour_completed",

  TESTFLIGHT_PROMPT_SHOWN: "testflight_prompt_shown",
  TESTFLIGHT_PROMPT_CTA_TAPPED: "testflight_prompt_cta_tapped",

  PUSH_PERMISSION_PROMPTED: "push_permission_prompted",
  PUSH_PERMISSION_GRANTED: "push_permission_granted",
  PUSH_PERMISSION_DENIED: "push_permission_denied",

  EVENT_REMINDER_SENT: "event_reminder_sent",
  EVENT_REMINDER_OPENED: "event_reminder_opened",

  EVENT_REMINDERS_TOGGLED: "event_reminders_toggled",
  CAPTURE_NOTIFICATIONS_TOGGLED: "capture_notifications_toggled",

  REMINDER_SETTINGS_NUDGE_SHOWN: "reminder_settings_nudge_shown",
  REMINDER_SETTINGS_NUDGE_TAPPED: "reminder_settings_nudge_tapped",

  ACTIVATION_NUDGE_SENT: "activation_nudge_sent",
  ACTIVATION_NUDGE_OPENED: "activation_nudge_opened",
  ACTIVATION_NUDGE_HELD_OUT: "activation_nudge_held_out",

  WEEKLY_DIGEST_SENT: "weekly_digest_sent",
  WEEKLY_DIGEST_OPENED: "weekly_digest_opened",
  WEEKLY_DIGEST_TOGGLED: "weekly_digest_toggled",

  SUPPORTER_ASK_ELIGIBLE: "supporter_ask_eligible",
  SUPPORTER_ASK_PRESENTED: "supporter_ask_presented",
  SUPPORTER_ASK_DISMISSED: "supporter_ask_dismissed",
  SUPPORTER_ASK_CTA_TAPPED: "supporter_ask_cta_tapped",
} as const;

export type AnalyticsEvent =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];

export const ANALYTICS_PROPS = {
  CREATOR_USERNAME: "creator_username",
  CREATOR_USER_ID: "creator_user_id",
  EVENT_CREATOR_ID: "event_creator_id",
  REFERRED_BY: "referred_by",
  SOURCE: "source",
  DESTINATION: "destination",
  CTA: "cta",
  INTAKE_METHOD: "intake_method",

  LINK_TYPE: "link_type",
  DEEP_LINK_VALUE: "deep_link_value",
  APP_ALREADY_INSTALLED: "app_already_installed",
  IS_NEW_USER: "is_new_user",
  AUTO_FOLLOWED: "auto_followed",
  CHOICE: "choice",
  HAS_PENDING_FOLLOW: "has_pending_follow",

  SCREEN: "screen",
  CONTEXT: "context",

  OUTCOME: "outcome",
  PROMPT_SHOWN: "prompt_shown",
  SAVE_OK: "save_ok",
  STATUS: "status",
  PERMISSION: "permission",
  PLATFORM: "platform",

  RESULT: "result",
  RESTORED: "restored",
  TIER_CHANGED: "tier_changed",

  REASON: "reason",
  ERROR_MESSAGE: "error_message",

  STAGE: "stage",
  METHOD: "method",
  TRANSFERRED: "transferred",
  HAD_REVENUECAT_ENTITLEMENT: "had_revenuecat_entitlement",

  COUNT: "count",
  SUCCESS_COUNT: "success_count",
  FAILURE_COUNT: "failure_count",
  TOTAL_COUNT: "total_count",
  DURATION_MS: "duration_ms",
  WAS_COLD_START: "was_cold_start",
  BATCH_ID: "batch_id",

  EVENT_ID: "event_id",
  IS_OWNER: "is_owner",
  IS_SAVED: "is_saved",
  HAS_LOCATION: "has_location",
  CHANGED_IMAGE: "changed_image",
  CHANGED_VISIBILITY: "changed_visibility",
  HAS_FIELD_CHANGES: "has_field_changes",
  VISIBILITY: "visibility",
  ACTION: "action",
  ENABLED: "enabled",

  LIST_ID: "list_id",
  IS_OWN_LIST: "is_own_list",
  SHARING_MODE: "sharing_mode",

  QUERY_LENGTH: "query_length",
  RESULT_COUNT: "result_count",
  HAS_RESULTS: "has_results",

  CALENDAR_APP: "calendar_app",
  MAPS_APP: "maps_app",

  URL: "url",
  NOTIFICATION_ID: "notification_id",
  SCHEME: "scheme",

  SEGMENT: "segment",
  FEED: "feed",
  EVENT_COUNT: "event_count",

  SLIDE: "slide",

  REMINDER_TYPE: "reminder_type",
  SEND_OK: "send_ok",

  STEP: "step",
  CHANNEL: "channel",

  STATE_BRANCH: "state_branch",

  SUPPRESSED: "suppressed",
  FORCED: "forced",
} as const;

export const PERSON_PROPS = {
  HAS_UNLIMITED: "has_unlimited",
  REFERRED_BY: "referred_by",
  HAS_COMPLETED_ONBOARDING: "has_completed_onboarding",
  SIGNUP_DATE: "signup_date",
  DAYS_SINCE_SIGNUP: "days_since_signup",
} as const;

export const PAYWALL_SOURCE = {
  ONBOARDING: "onboarding",
  SETTINGS: "settings",
  SUPPORTER_POSTCARD: "supporter_postcard",
} as const;

export type PaywallSource =
  (typeof PAYWALL_SOURCE)[keyof typeof PAYWALL_SOURCE];

export const SUBSCRIPTION_MANAGE_DESTINATION = {
  WEB: "web",
} as const;

export const CAPTURE_INTAKE_METHOD = {
  PHOTO_PICKER: "photo_picker",
  CAMERA: "camera",
  LINK_CLIPBOARD: "link_clipboard",
  WEB_SEARCH: "web_search",
  SHARE_EXTENSION: "share_extension",
  DICTATION: "dictation",
  MCP: "mcp",
  UNKNOWN: "unknown",
} as const;

export type CaptureIntakeMethod =
  (typeof CAPTURE_INTAKE_METHOD)[keyof typeof CAPTURE_INTAKE_METHOD];

export const SIGN_IN_METHOD = {
  APPLE: "apple",
  GOOGLE: "google",
  EMAIL: "email",
} as const;

export type SignInMethod = (typeof SIGN_IN_METHOD)[keyof typeof SIGN_IN_METHOD];

export const SHARE_SETUP_METHOD = {
  COPY: "copy",
  SEND: "send",
} as const;

export type ShareSetupMethod =
  (typeof SHARE_SETUP_METHOD)[keyof typeof SHARE_SETUP_METHOD];

export const WELCOME_CTA_CHOICE = {
  GET_STARTED: "get_started",
  SIGN_IN: "sign_in",
} as const;

export type WelcomeCtaChoice =
  (typeof WELCOME_CTA_CHOICE)[keyof typeof WELCOME_CTA_CHOICE];

export const DEEP_LINK_TYPE = {
  DIRECT: "direct",
  DEFERRED: "deferred",
} as const;

export type DeepLinkType = (typeof DEEP_LINK_TYPE)[keyof typeof DEEP_LINK_TYPE];

export const NOTIFICATION_PERMISSION_OUTCOME = {
  ALREADY_GRANTED: "already_granted",
  PROMPT_GRANTED: "prompt_granted",
  PROMPT_DENIED: "prompt_denied",
  SOFT_DECLINED: "soft_declined",
} as const;

export type NotificationPermissionOutcome =
  (typeof NOTIFICATION_PERMISSION_OUTCOME)[keyof typeof NOTIFICATION_PERMISSION_OUTCOME];

export const PAYWALL_DISMISS_RESULT = {
  CANCELLED: "cancelled",
  ERROR: "error",
} as const;

export type PaywallDismissResult =
  (typeof PAYWALL_DISMISS_RESULT)[keyof typeof PAYWALL_DISMISS_RESULT];

export const PAYWALL_SKIP_REASON = {
  INIT_TIMEOUT: "init_timeout",
  INIT_FAILED: "init_failed",
  PREFLIGHT_TIMEOUT: "preflight_timeout",
  NO_CURRENT_OFFERING: "no_current_offering",
  NO_PACKAGES: "no_packages",
} as const;

export type PaywallSkipReason =
  (typeof PAYWALL_SKIP_REASON)[keyof typeof PAYWALL_SKIP_REASON];

export const LIST_SUBSCRIBE_ACTION = {
  SUBSCRIBE: "subscribe",
  UNSUBSCRIBE: "unsubscribe",
} as const;

export type ListSubscribeAction =
  (typeof LIST_SUBSCRIBE_ACTION)[keyof typeof LIST_SUBSCRIBE_ACTION];

export const LIST_SUBSCRIBE_SOURCE = {
  DISCOVER_FEATURED: "discover_featured",
  FIND_BY_NAME: "find_by_name",
  PROFILE: "profile",
  REFERRAL_EMPTY_STATE: "referral_empty_state",
  SUBSCRIBED_SCREEN: "subscribed_screen",
  REFERRAL_AUTO_FOLLOW: "referral_auto_follow",
} as const;

export type ListSubscribeSource =
  (typeof LIST_SUBSCRIBE_SOURCE)[keyof typeof LIST_SUBSCRIBE_SOURCE];

export const EVENT_LIST_ACTION = {
  ADD: "add",
  REMOVE: "remove",
} as const;

export type EventListAction =
  (typeof EVENT_LIST_ACTION)[keyof typeof EVENT_LIST_ACTION];

export const EVENT_VISIBILITY = {
  PUBLIC: "public",
  PRIVATE: "private",
} as const;

export type EventVisibility =
  (typeof EVENT_VISIBILITY)[keyof typeof EVENT_VISIBILITY];

export const FEED_SEGMENT = {
  UPCOMING: "upcoming",
  GOING: "going",
  PAST: "past",
} as const;

export type FeedSegment = (typeof FEED_SEGMENT)[keyof typeof FEED_SEGMENT];

export const WHATS_NEW_SLIDE = {
  TRY_IT: "try_it",
  ENRICHMENT: "enrichment",
  YOUR_LIST: "your_list",
  ADD_ANY_PHOTO: "add_any_photo",
  CAPTURE_SHARE: "capture_share",
} as const;

export type WhatsNewSlide =
  (typeof WHATS_NEW_SLIDE)[keyof typeof WHATS_NEW_SLIDE];

export const REMINDER_TYPE = {
  DAY_BEFORE: "day_before",
  DAY_OF: "day_of",
} as const;

export type ReminderType = (typeof REMINDER_TYPE)[keyof typeof REMINDER_TYPE];

export const FEED_KIND = {
  MY_SOONLIST: "my_soonlist",
  MY_SCENE: "my_scene",
} as const;

export type FeedKind = (typeof FEED_KIND)[keyof typeof FEED_KIND];

export const GUEST_DATA_TRANSFER_STATUS = {
  TRANSFERRED: "transferred",
  DEFERRED: "deferred",
  FAILED: "failed",
  DISCARDED: "discarded",
  NO_GUEST_DATA: "no_guest_data",
} as const;

export type GuestDataTransferStatus =
  (typeof GUEST_DATA_TRANSFER_STATUS)[keyof typeof GUEST_DATA_TRANSFER_STATUS];

export const PUBLIC_LIST_CTA = {
  SUBSCRIBE: "subscribe",
  HEADER_GET_APP: "header_get_app",
  SAVE_EVENT: "save_event",
  OPEN_IN_APP: "open_in_app",
  FOOTER_APP_STORE: "footer_app_store",
  FOOTER_GOOGLE_PLAY: "footer_google_play",
} as const;

export type PublicListCta =
  (typeof PUBLIC_LIST_CTA)[keyof typeof PUBLIC_LIST_CTA];

export const PUBLIC_PAGE_SOURCE = {
  LIST_PAGE: "list_page",
  EVENT_PAGE: "event_page",
  NAMED_LIST_PAGE: "named_list_page",
  MARKETING_PAGE: "marketing_page",
} as const;

export type PublicPageSource =
  (typeof PUBLIC_PAGE_SOURCE)[keyof typeof PUBLIC_PAGE_SOURCE];
